import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { Configuracion } from './file-upload.component';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilidadesService } from '../../utilidades.servicios.index';

@Component({
	selector: 'file-upload-configuracion',
	templateUrl: './file-upload-configuracion.component.html'
})
export class FileUploadConfiguracionComponent {

	public _configuracion: Configuracion = new Configuracion();

	@Input() Configuracion: string = "";
	@Output() ConfiguracionChange: EventEmitter<string> = new EventEmitter<string>();

	private Ventana: MatDialogRef<any, any>;
	@ViewChild("PopUpConfig") PopUpConfig: TemplateRef<any>;

	constructor(public Utilidades: UtilidadesService) { }

	AbrirConfiguracion(): void {
		if (this.Configuracion) {
			this._configuracion = JSON.parse(this.Configuracion);
		}

		this.Ventana = this.Utilidades.CuadroHTML(this.PopUpConfig, "60vw");
	}

	Aceptar(): void {
		this.Configuracion = JSON.stringify(this._configuracion);
		this.ConfiguracionChange.emit(this.Configuracion);
		this.Ventana.close();
	}

	Cancelar(): void {
		this.Ventana.close();
	}

	Restablecer(): void {
		this._configuracion = new Configuracion();
	}
}